import React from 'react';
import { urlMap, urlConstructor } from 'routes/urlMap';
import { faHouse } from '@fortawesome/pro-regular-svg-icons';
import { NavLink } from '../components';

export const HomeLink = (props) => (
  <NavLink
    {...props}
    icon={faHouse}
    textPath="navbar.home"
    displayPath="/home"
    url={urlConstructor(urlMap.DASHBOARD)}
    name="home"
  />
);
